
import { firebase } from "common";
import { TFunction } from "react-i18next";
import { II18nextTypes } from "common/src/types/i18n";
import { get, onValue, push } from "firebase/database";
import { FormatBookingObjectNew } from "./FormatObject";
import { IAddBookingObjType, IBookingType } from "common/src/types";
import { RequestPushMsg } from "common/src/other/NotificationFunctions";

interface CreateBookingFirebaseNewProps {
    t: TFunction;
    addBookingObj: IAddBookingObjType
}

interface CreateBookingFirebaseNewResponse {
    error?: boolean;
    msg?: keyof II18nextTypes;
    bookingData?: IBookingType;
}

export const CreateBookingFirebaseNew = async ({ addBookingObj, t }: CreateBookingFirebaseNewProps): Promise<CreateBookingFirebaseNewResponse> => {
    const {
        bookingRef,
        settingsRef,
        singleUserRef
    } = firebase;

    try {
        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val();

        if (addBookingObj.requestedDrivers) {
            const drivers = addBookingObj.requestedDrivers;
            Object.keys(drivers).map((uid) => {
                onValue(singleUserRef(uid), snapshot => {
                    if (snapshot.val()) {
                        const pushToken = snapshot.val().pushToken;
                        const ios = snapshot.val().userPlatform == "IOS" ? true : false
                        if (pushToken) {
                            RequestPushMsg(
                                pushToken,
                                {
                                    ios: ios,
                                    screen: 'DriverTrips',
                                    title: t("notification_title"),
                                    msg: t("new_booking_notification"),
                                    channelId: settings.CarHornRepeat ? 'bookings-repeat' : 'bookings',
                                });
                        }
                    }
                }, { onlyOnce: true });
                return drivers[uid as any];
            })
        }

        let data = await FormatBookingObjectNew({ settings, addBookingObj });


        if (data?.error) {
            return {
                error: data?.error,
                msg: data?.msg
            };
        }

        const res = await push(bookingRef, data.addBookingObj);
        const bookingKey = res.key;


        return {
            bookingData: {
                ...data,
                id: bookingKey!
            } as any
        };

    } catch (error) {
        console.error(error);
        return {
            error: true,
            msg: error as any
        };
    }
};